import { render, staticRenderFns } from "./StudentCourseDetailModal.vue?vue&type=template&id=2a40a1e5&scoped=true"
import script from "./StudentCourseDetailModal.vue?vue&type=script&lang=js"
export * from "./StudentCourseDetailModal.vue?vue&type=script&lang=js"
import style0 from "./StudentCourseDetailModal.vue?vue&type=style&index=0&id=2a40a1e5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a40a1e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a40a1e5')) {
      api.createRecord('2a40a1e5', component.options)
    } else {
      api.reload('2a40a1e5', component.options)
    }
    module.hot.accept("./StudentCourseDetailModal.vue?vue&type=template&id=2a40a1e5&scoped=true", function () {
      api.rerender('2a40a1e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/course/components/StudentCourseDetailModal.vue"
export default component.exports